var _linearGradient, _linearGradient2, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCbaEntryLedger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 198.425 198.425",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_b09cd98fb38b11e33c3091116bcb2d12b1c8544afc5d38c25fbd042710152654",
    gradientUnits: "userSpaceOnUse",
    x1: 167.402,
    y1: -13.591,
    x2: 168.402,
    y2: -13.591
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_b09cd98fb38b11e33c3091116bcb2d12b1c8544afc5d38c25fbd042710152654",
    gradientUnits: "userSpaceOnUse",
    x1: 67.924,
    y1: 128.09,
    x2: 140.483,
    y2: 128.09
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_1_b09cd98fb38b11e33c3091116bcb2d12b1c8544afc5d38c25fbd042710152654)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M69.174 128.09h70.059"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M87.63 94.458h26.385M92.027 99.995h16.939"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M139.233 121.885V24.819H57.367l.057 102.73"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M139.233 121.883H63.635c-3.416 0-6.211 2.795-6.211 6.211 0 3.416 2.795 6.211 6.211 6.211h75.598v-12.422zM62.962 91.694v8.315M62.962 47.629v8.315M118.904 108.831H82.252a5.86 5.86 0 01-5.86-5.86v-11a5.86 5.86 0 015.86-5.86h36.652a5.86 5.86 0 015.86 5.86v11a5.86 5.86 0 01-5.86 5.86z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M92.19 63.074h20.864M108.141 56.468l6.67 6.671-6.748 7.066M107.5 48.428H85.884M90.797 55.034l-6.67-6.67 6.748-7.067"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCbaEntryLedger);
export default __webpack_public_path__ + "static/media/cbaEntryLedger.5a8b9cc343db872d84e197aff71fb921.svg";
export { ForwardRef as ReactComponent };